import React from "react";

const ProductsLoader = ({ isInitialLoad = false, isCart = false }) => {
  if (isInitialLoad && isCart) {
    return (
      <div className="w-full bg-white rounded-lg shadow-sm p-8 text-center min-h-[300px] flex items-center justify-center">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500 mb-4"></div>
          <p className="text-gray-600 text-lg">Loading your cart...</p>
          <p className="text-gray-500 text-sm mt-2">Please wait while we fetch your cart items</p>
        </div>
      </div>
    );
  }

  if (isInitialLoad) {
    return (
      <div className="w-full bg-white rounded-lg shadow-sm p-8 text-center min-h-[300px] flex items-center justify-center">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500 mb-4"></div>
          <p className="text-gray-600 text-lg">Loading products...</p>
          <p className="text-gray-500 text-sm mt-2">Please wait while we fetch the latest products</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full bg-white rounded-lg shadow-sm p-8 text-center min-h-[300px] flex items-center justify-center">
      <div className="flex flex-col items-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500 mb-4"></div>
        <p className="text-gray-600 text-lg">Searching for products...</p>
        <p className="text-gray-500 text-sm mt-2">Please wait while we find the best matches for you</p>
      </div>
    </div>
  );
};

export default ProductsLoader; 